import { WebSleepStatService } from './web';
export default WebSleepStatService;
